import { render } from "./TableAllInvoices.vue?vue&type=template&id=c8931db6&scoped=true"
import script from "./TableAllInvoices.vue?vue&type=script&lang=js"
export * from "./TableAllInvoices.vue?vue&type=script&lang=js"

import "./TableAllInvoices.vue?vue&type=style&index=0&id=c8931db6&lang=scss&scoped=true"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8931db6"]])

export default __exports__